import styled from 'styled-components'

export const MHSelectContainer = styled.div`
  svg {
    transform: scale(1.5);
  }
`
